var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdealTime = function SvgIdealTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.27 8.246c-.484.476-1.173.476-1.649 0-.088-.096-.227-.286-.315-.403L3.846 4.29c-.125-.176-.089-.345.014-.462.11-.102.286-.139.461-.015l3.553 2.469c.117.08.307.22.395.307.483.484.483 1.172 0 1.656"
  })));
};
export default SvgIdealTime;